// extracted by mini-css-extract-plugin
export var columnList = "_gm-0";